import { AbstractFieldGroupView } from '../base/AbstractFieldGroupView';
import { NumberInputView } from '../../../../../renderApp/components/cells/BaseInput/views/NumberInputView';
import { BaseInputFactory } from '../../../../../renderApp/components/cells/BaseInput/BaseInputFactory';
import input_klass from '../../../../../renderApp/components/cells/DateInputField/styles/BaseInputView.module.scss';
import { html } from 'rune-ts';
import { limited_identifier } from '../../../../features/ProductEditor/const/limited';
import { IVisibleController, VisibleController } from '../../../../../shared/util/VisibleController';
import klass from './SaleStartDateInputField.module.scss';
import { head, isUndefined } from '@fxts/core';
import { IValidation, ProductEditorError } from '../types/type';

export class MaxPerUserInputField
  extends AbstractFieldGroupView<number | undefined>
  implements IVisibleController, IValidation
{
  private readonly inputView: NumberInputView;
  private visibleController: VisibleController;

  private error_message?: string;

  private static readonly min = 1;
  private static readonly max = 999_999;
  private static readonly step = 1;

  constructor({ value }: { value: number | undefined }) {
    const visible = !!value;

    super(value, T('1인당 구매 수량 제한'), true, undefined, visible);
    this.inputView = BaseInputFactory.create(
      'number',
      value,
      {
        name: limited_identifier.max_purchase_per_user,
        min: MaxPerUserInputField.min,
        max: MaxPerUserInputField.max,
        step: MaxPerUserInputField.step,
      },
      {
        klass: input_klass.input,
      },
    );
    this.visibleController = new VisibleController(this, visible);
  }

  protected body() {
    return html`<div>
      ${this.inputView}
      <span class="${klass.error_message} ${this.isErrorMessageVisible() ? '' : klass.hidden}">
        ${this.error_message}
      </span>
    </div>`;
  }

  public getValue(): number | undefined {
    return this.inputView.getValue();
  }

  public clear(): this {
    this.inputView.setValueAndSync(undefined);
    return this;
  }

  public setVisible(visible: boolean): this {
    if (visible) {
      this.show();
    }
    this.visibleController.setVisible(visible);
    return this;
  }

  public setErrorMessage(message?: string): this {
    this.error_message = message;
    this.syncErrorMessage();
    return this;
  }

  private isErrorMessageVisible(): boolean {
    return !!this.error_message;
  }

  private syncErrorMessage() {
    const error_el = this.element().querySelector(`.${klass.error_message}`);
    if (error_el) {
      (error_el as HTMLElement).innerText = this.error_message || '';
      this.inputView.setError(this.isErrorMessageVisible());

      if (this.isErrorMessageVisible()) {
        error_el.classList.remove(klass.hidden);
      } else {
        error_el.classList.add(klass.hidden);
      }
    }
  }

  public validate(): ProductEditorError[] {
    const errors = [];

    if (this.isRequired() && this.isVisible() && isUndefined(this.inputView.getValue())) {
      errors.push({
        target: this,
        title: '1인당 구매 수량 제한 미입력',
        message: '1인당 구매 수량을 입력해주세요.',
        detail: '1인당 구매 수량을 입력해주세요.',
      });
    }
    return errors;
  }

  public showValidation(): this {
    const first_error = head(this.validate());
    this.setErrorMessage(first_error?.message);
    return this;
  }

  public isVisible(): boolean {
    return this.visibleController.isVisible();
  }
}
